import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, Warning, Spinner } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function NotifyResolve() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${BASE}/api/public/notification-resolve/${token}`);
        setState({ loading: false, ok: true, data });
      } catch (e) {
        setState({ loading: false, ok: false,
          error: e.response?.data?.detail || "Link expired or invalid" });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-6" data-testid="notify-resolve-page">
      <div className="max-w-lg w-full bg-white border-2 border-[#0f172a] p-8 shadow-2xl">
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-2">
          Field Radar · Escalation Chain
        </div>
        {state.loading && (
          <div className="flex items-center gap-3 text-slate-700">
            <Spinner weight="bold" size={24} className="animate-spin"/>
            <span className="font-bold">Closing ticket…</span>
          </div>
        )}
        {!state.loading && state.ok && (
          <div className="flex items-start gap-3 text-emerald-800">
            <CheckCircle weight="fill" size={28}/>
            <div>
              <h1 className="font-display font-black text-2xl">
                {state.data.state === "already_resolved" ? "Already Closed" : "Ticket Closed"}
              </h1>
              <p className="mt-2 text-sm text-slate-700">
                {state.data.message || "Field Radar will not escalate this request further."}
              </p>
              {state.data.resolved_at && (
                <p className="mt-2 text-xs font-mono text-slate-500">
                  Closed: {new Date(state.data.resolved_at).toLocaleString()}
                </p>
              )}
            </div>
          </div>
        )}
        {!state.loading && !state.ok && (
          <div className="flex items-start gap-3 text-red-800" data-testid="notify-resolve-error">
            <Warning weight="fill" size={28}/>
            <div>
              <h1 className="font-display font-black text-2xl">Link Invalid</h1>
              <p className="mt-2 text-sm">{state.error}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
